import { PAGES } from '../constants/complaint-constants';
export default {
	data() {
		return {
			dots: []
		};
	},
	props: ['currentPage', 'visitedPages', 'validPages'],
	methods: {
		isVisitedPage(link) {
			return this.visitedPages.indexOf(link) != -1;
		},
		isLastPage(link) {
			return this.visitedPages[this.visitedPages.length - 1] == link;
		},
		getIndexOfPage(link) {
			return PAGES.findIndex((page) => page.link == link);
		},
		updateDotList() {
			this.dots = PAGES.map((dot) => {
				dot.editUrl = this.isVisitedPage(dot.link) && this.currentPage != dot.link ? `#${dot.link}` : '';
				const index = this.getIndexOfPage(dot.link);
				const indexOfCurrent = this.getIndexOfPage(this.currentPage);
				const visited = this.isVisitedPage(dot.link);
				if (visited) {
					dot.pending = index > indexOfCurrent;
					dot.done = index < indexOfCurrent;
				}
				dot.current = this.currentPage == dot.link;
				return dot;
			});
		}
	},
	watch: {
		currentPage() {
			this.updateDotList();
		}
	},
	created() {
		this.updateDotList();
	},
	render() {
		return this.$scopedSlots.default({
			steps: this.dots
		});
	}
};
